export const OrderIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
        >
            <path
                d="M10 4.35498V16.355M10 4.35498C10 2.69813 11.3431 1.35498 13 1.35498H18C18.5523 1.35498 19 1.8027 19 2.35498V12.355C19 12.9073 18.5523 13.355 18 13.355H13.6056C12.6025 13.355 11.6658 13.8563 11.1094 14.6909L10 16.355M10 4.35498C10 2.69813 8.65685 1.35498 7 1.35498H2C1.44772 1.35498 1 1.8027 1 2.35498V12.355C1 12.9073 1.44772 13.355 2 13.355H6.39445C7.39751 13.355 8.3342 13.8563 8.8906 14.6909L10 16.355"
                stroke="#040404"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
